module.exports = __webpack_public_path__ + "img/rules.2e2a6113.png";